import { useState, useEffect } from "react";
import { ArrayInput, SimpleFormIterator, FormDataConsumer } from 'react-admin';
import { Checkbox, IconButton } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { Typography } from '@material-ui/core';
import { SelectInput } from "ra-ui-materialui";
import DeleteIcon from '@material-ui/icons/Delete';
import { useFormState, useForm, useField } from "react-final-form";
import { Button } from 'react-admin';
import { getConfigurationTypeValue } from '../../services/master-tables.service'

const AffinityForm = props => {
    const [selectedUsers, setSelectedUsers] = useState({});
    const [errors, setErrors] = useState({});
    const { record: { participants }, record } = props;
    const [clientAffinityList, setClientAffinityList] = useState(props?.clientAffinityList || []);
    const [configurationTypeValue, setConfigurationTypeValue] = useState();

    const form = useForm();
    const { values } = useFormState();

    useEffect(() => {
        getConfigurationTypeValue().then(
            res => {
                if(res && res.elements){
                    var afin = res?.elements.find(f =>f?.subType === "AFIN");
                    if(afin) setConfigurationTypeValue(parseInt(afin.value));
                }
            }
        )
    }, []);
/* 
     // Actualizar estado global de errores
     useEffect(() => {
        const hasValidationErrors = Object.values(errors).some(error => error !== null);
        console.log(hasValidationErrors)
        setAffinityErrors(hasValidationErrors);
    }, [errors, setAffinityErrors]); */

    // Función para verificar duplicados
    const checkForDuplicates = (currentList, index, newA, newB) => {
        // Normalizar los IDs para comparación (ordenados)
        const normalizePair = (a, b) => [a, b].sort().join('-');
        
        const currentPair = normalizePair(newA, newB);
        
        for (let i = 0; i < currentList.length; i++) {
            if (i === index) continue; // Saltar el índice actual que estamos editando
            
            const a = currentList[i]?.clientAId;
            const b = currentList[i]?.clientBId;
            
            if (a && b) {
                const existingPair = normalizePair(a, b);
                if (existingPair === currentPair) {
                    return true;
                }
            }
        }
        return false;
    };

    // Función para validar si todos los campos requeridos están completos
    const validateRequiredFields = (index) => {
        const currentItem = clientAffinityList[index] || {};
        const hasUserA = !!currentItem.clientAId;
        const hasUserB = !!currentItem.clientBId;
        const hasAffinityScore = currentItem.affinityScore !== undefined && 
                                currentItem.affinityScore !== null && 
                                currentItem.affinityScore !== 0;

        // Si alguno de los campos está completado pero no todos
        if ((hasUserA || hasUserB || hasAffinityScore) && !(hasUserA && hasUserB && hasAffinityScore)) {
            return "Debe completar todos los campos";
        }
        return null;
    };

    const handleChange = (id, index) => {
        var affinityScore = id === 0 ? configurationTypeValue : (configurationTypeValue * -1);
        var clientAffinityListClone = [...clientAffinityList];

        if (!record.clientAffinity) record.clientAffinity = [];
        if (!record.clientAffinity[index]) record.clientAffinity[index] = {};
        if (!clientAffinityListClone[index]) clientAffinityListClone[index] = {};

        clientAffinityListClone[index].affinityScore = affinityScore;
        record.clientAffinities[index].affinityScore = affinityScore;
        setClientAffinityList(clientAffinityListClone);

        // Validar después de cambiar
        const validationError = validateRequiredFields(index);
        setErrors({
            ...errors,
            [`${index}-required`]: validationError
        });
    };

    const handleDelete = (value, indexCustom) => {

        const updatedAffinities = [...record.clientAffinities];
        updatedAffinities.splice(indexCustom, 1);
        /* const updatedAffinities = record?.clientAffinities.filter(
            aff => aff.id !== value.id
        ); */

        form.change('clientAffinities', updatedAffinities);
        values.clientAffinities = updatedAffinities;
        setClientAffinityList(updatedAffinities);
        record.clientAffinities = updatedAffinities;
        onChange(updatedAffinities);
    };

    const handleChangeUser = (index, nextValue, userType) => {
        const newValue = nextValue?.target?.value;
        const updatedSelectedUsers = { ...selectedUsers, [userType + index]: newValue };
        setSelectedUsers(updatedSelectedUsers);

        const clientAffinityListClone = [...clientAffinityList];
        if (!clientAffinityListClone[index]) clientAffinityListClone[index] = {};
        
        // Obtener los valores actuales y el nuevo valor
        const currentA = userType === 'clientAId' ? newValue : clientAffinityListClone[index]?.clientAId;
        const currentB = userType === 'clientBId' ? newValue : clientAffinityListClone[index]?.clientBId;
        
        // Validación 1: Mismo usuario en ambos campos
        const sameUserError = currentA && currentB && currentA === currentB 
            ? "No puedes seleccionar el mismo usuario en ambos campos" 
            : null;
        
        // Validación 2: Comprobar duplicados
        let duplicateError = null;
        if (currentA && currentB) {
            duplicateError = checkForDuplicates(clientAffinityListClone, index, currentA, currentB) 
                ? "Esta combinación de usuarios ya existe" 
                : null;
        }
        
        // Validación 3: Campos requeridos
        clientAffinityListClone[index][userType] = newValue;
        const requiredError = validateRequiredFields(index);

        // Actualizar errores
        setErrors({
            ...errors,
            [`${index}-sameUser`]: sameUserError,
            [`${index}-duplicate`]: duplicateError,
            [`${index}-required`]: requiredError
        });
        
        // Si hay errores críticos (mismo usuario o duplicado), no actualizamos los valores
        if (sameUserError || duplicateError) {
            return;
        }
        
        // Actualizar los datos si no hay errores críticos
        clientAffinityListClone[index][userType] = newValue;
        clientAffinityListClone[index].scheduledActivityId = record?.id;

        if (!record.clientAffinities) record.clientAffinities = [];
        if (!record.clientAffinities[index]) record.clientAffinities[index] = {};

        record.clientAffinities[index][userType] = newValue;
        record.clientAffinities[index].scheduledActivityId = record?.id;

        setClientAffinityList(clientAffinityListClone);
        form.change('clientAffinities', clientAffinityListClone);
        onChange(clientAffinityListClone);
    };

    const CustomRemoveButton = ({ data, indexCustom }) => (
        <Button
            style={{ color: "red" }}
            label="Eliminar"
            onClick={() => {
                handleDelete(data, indexCustom);
            }}
        >
            <DeleteIcon color="red" />
        </Button>
    );

    const {
        input: { onChange },
        meta: { touched, error }
    } = useField('clientAffinities');

    return (
        <div style={{ maxHeight: '450px' }}>
            <ArrayInput
                label="Afinidades"
                source="clientAffinities"
                id="arrayCustomUserAffinity"
                defaultValue={clientAffinityList || []}
                error={!!(touched && error) ? error : null}
                
            >
                <SimpleFormIterator disableRemove={true}>
                    <FormDataConsumer>
                        {({ scopedFormData, getSource }) => {
                            const source = getSource('');
                            const indexMatch = source.match(/\[(\d+)\]/);
                            const indexCustom = indexMatch ? indexMatch[1] : null;

                            return (
                                <>
                                    <div id="selectInputUser" style={{ marginBottom: '10px', marginRight: '20px' }}>
                                        <SelectInput                                           
                                            label='Usuario'
                                            disabled={!scopedFormData?.id === 0 || scopedFormData?.id !== undefined}
                                            source={`${source}${"clientAId"}`}
                                            choices={participants}
                                            onChange={(event) => handleChangeUser(indexCustom, event, 'clientAId')}
                                            optionText={(data) => `${data.identificationNumber || ''} - ${data.name || ''} ${data.surnames || ''}`}
                                            error={errors[`${indexCustom}-sameUser`] || errors[`${indexCustom}-duplicate`] || errors[`${indexCustom}-required`]}
                                            helperText={errors[`${indexCustom}-sameUser`] || errors[`${indexCustom}-duplicate`] || errors[`${indexCustom}-required`]}
                                        />
                                    </div>
                                    <div id="selectInputUser" style={{ marginRight: '20px' }}>
                                        <SelectInput
                                            label='Usuario'
                                            disabled={!scopedFormData?.id === 0 || scopedFormData?.id !== undefined}
                                            source={`${source}${"clientBId"}`}
                                            choices={participants}
                                            onChange={(event) => handleChangeUser(indexCustom, event, 'clientBId')}
                                            optionText={(data) => `${data.identificationNumber || ''} - ${data.name || ''} ${data.surnames || ''}`}
                                            error={errors[`${indexCustom}-sameUser`] || errors[`${indexCustom}-duplicate`] || errors[`${indexCustom}-required`]}
                                            helperText={errors[`${indexCustom}-sameUser`] || errors[`${indexCustom}-duplicate`] || errors[`${indexCustom}-required`]}                                       
                                        />
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: '-3.5%' }}>
                                        <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                            <div style={{ textAlign: "center", display: "flex", flexDirection: "column" }}>
                                                <Typography style={{ color: 'grey' }} variant="caption">Alta</Typography>
                                                <IconButton className="button-affinity">
                                                    <CheckCircleIcon style={{ color: "teal" }} />
                                                </IconButton>
                                            </div>
                                            <div style={{ textAlign: "center", display: "flex", flexDirection: "column" }}>
                                                <Typography style={{ color: 'grey' }} variant="caption">Baja</Typography>
                                                <IconButton className="button-affinity">
                                                    <CancelIcon style={{ color: "red" }} />
                                                </IconButton>
                                            </div>
                                        </div>
                                        <div key={indexCustom} style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                                            {[0, 1].map((index) => (
                                                <Checkbox
                                                    key={`${source}-checkbox-${index}`}
                                                    source={`${source}affinityScore`}
                                                    checked={
                                                        clientAffinityList[indexCustom]?.affinityScore === undefined ||
                                                            clientAffinityList[indexCustom]?.affinityScore === null ||
                                                            clientAffinityList[indexCustom]?.affinityScore === 0
                                                            ? false
                                                            : index === 0
                                                                ? clientAffinityList[indexCustom]?.affinityScore === configurationTypeValue
                                                                : clientAffinityList[indexCustom]?.affinityScore === (configurationTypeValue * -1)
                                                    }
                                                    onChange={() => handleChange(index, indexCustom)}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    <div style={{ alignContent: 'baseline', marginLeft: '50px' }}>
                                        <CustomRemoveButton data={scopedFormData} indexCustom={indexCustom} />
                                    </div>
                                </>
                            );
                        }}
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
        </div>
    );
};

export default AffinityForm;